import KButton from './KButton'
import Modal from 'react-bootstrap/Modal'
import { t } from '../locale'

function KConfirm(props: any) {
  return (
    <Modal id='confirm' show={props.show} centered>
      <Modal.Header>
        <Modal.Title className='m-auto'>{t('areYouSure')}</Modal.Title>
      </Modal.Header>

      {!!props.message && <Modal.Body>{props.message}</Modal.Body>}

      <Modal.Footer className='d-block'>
        <KButton
          id='btn-confirm-cancel'
          icon='stars'
          variant='danger'
          className='text-white'
          onClick={props.onCancel}
          label={t('cancel')}
        />

        <KButton
          id='btn-confirm-proceed'
          icon='check'
          variant='success'
          className='f-right text-white'
          onClick={props.onConfirm}
          disabled={props.confirmDisabled}
          label={t('proceed')}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default KConfirm
